// Path matching for the rail, the tab bar and the breadcrumb; no imports, so a node test can load it.
export function matches(pathname: string, to: string): boolean {
  return pathname === to || pathname.startsWith(to + '/')
}

/** Only the most specific entry is current: `/settings` is not, on `/settings/weights`, when that has its own entry. */
export function isActiveAmong(pathname: string, to: string, all: readonly string[]): boolean {
  return matches(pathname, to) && !all.some((o) => o !== to && o.startsWith(to + '/') && matches(pathname, o))
}
